<script>
import options from './SortDropdown.options'
export default options
</script>

<template>
  <article class="kb-sort-dropdown kb-forms">
    <div class="Form__Element FormSelection-sorting">
      <select
        id="sort-dropdown"
        @change="sortingHandler(sortingValue)"
        v-model="sortingValue"
      >
        <option value="" disabled>{{ config.name }}</option>
        <template v-for="(option, index) in config.options" :key="index">
          <option :value="option.handler">{{ option.name }}</option>
        </template>
      </select>
    </div>
  </article>
</template>
